export const ACCESS_TOKEN_KEY: string = "_at";
export const CANVAS_ID_KEY: string = "_cid"
export const VERIFICATION_TOKEN_KEY: string = "_vt"
